/* eslint-disable */

var bonzo = require('bonzo');
var domutils = require('../domutils');
var mutils = require('../math-utils');
var totalPrices = require('./total-prices');
var rest = require('./rest');
var _pick = require('lodash.pick');
var _forIn = require('lodash.forin');
var _forEach = require('lodash.foreach');

var scheduledDownTime = require('./scheduled-down-time');
var BasketPrices = window.BasketPrices;
var GiftCardsSettings = window.GiftCardsSettings;
var appState = window.appState;

var data = {
  items: [],
  elements: {},
  prices: {},
  giftcardsLimit: null
};

var animateScrollTo = function(position) {
  $('html,body').animate({ scrollTop: position }, 700);
};

function scrollIfNotOnScreen(elem){
  var docViewTop = $(window).scrollTop();
  var docViewBottom = docViewTop + $(window).height();
  var elemTop = $(elem).offset().top;
  var elemBottom = elemTop + $(elem).height();
  var scrollPosition = elemTop - 150;

  if (elemBottom > docViewBottom) {
    animateScrollTo(scrollPosition);
  } else if (elemTop < docViewTop) {
    animateScrollTo(scrollPosition);
  }
}

var findElements = function() {
  data.elements.total = domutils.qclass('total-amount')[0];
  data.elements.toPay = domutils.qclass('to-pay-amount')[0];
  data.elements.error = domutils.qclass('giftcard-list-error');
  data.elements.info = domutils.qclass('giftcard-list-info')[0];
  data.elements.orderForm = domutils.qid('form-payment-method');
  data.elements.continueFormPart = domutils.q('.continue-form-part', data.elements.orderForm);
  data.elements.placeOrderFormPart = domutils.q('.place-order-form-part', data.elements.orderForm);
  data.elements.paymentMethodSelect = domutils.q('#paymentMethod', data.elements.orderForm);
  data.elements.giftcardsHidden = domutils.q('input[name="giftcards"]', data.elements.orderForm);
};

var findGiftcardFormElements = function(giftcardFormElement) {
  data.elements.giftcardForm = {
    form: giftcardFormElement,
    formContent: domutils.q('div.form-content', giftcardFormElement),
    label: domutils.q('legend label', giftcardFormElement)
  };

  data.defaultGiftcardLabel = data.elements.giftcardForm.label.innerHTML;
};

var loadValues = function() {
  var globalPrices = BasketPrices;
  var globalSettings = GiftCardsSettings;
  data.prices.discount = globalPrices.fTotalDiscount;
  data.prices.total = globalPrices.fTotalPrice + globalPrices.fTotalServices + globalPrices.fTotalDelivery;
  data.prices.support = globalPrices.fTotalSupport;
  data.prices.toPay = data.prices.total + data.prices.support;
  data.giftcardsLimit = globalSettings.iCardsAllowed;
  data.prefix = globalSettings.sCardPrefixNumber;
  data.serviceAvailable = globalSettings.bGiftCardsAvailable;
  data.giftcardMaximumTotalValue = globalSettings.fGiftcardMaximumTotalValue;
  data.scheduled = globalSettings.bScheduled ? scheduledDownTime(globalSettings.bScheduled) : false;
};

var bindEvents = function() {
  if(data.elements.orderForm){
    $(data.elements.orderForm).on('submit',  function(event) {
      if (toReturn.editLock()) {
        domutils.preventDefault(event);
        return;
      }
      var result = [];
      _forEach(data.items, function(item) {
        var toSerialize = _pick(item,['amount','balance','cardNumber','pin']);
        toSerialize.cardNumber = toReturn.getCarsPrefix() + toSerialize.cardNumber;
        result.push(toSerialize);
      });

      if(result.length > 0){
        data.elements.giftcardsHidden.value = JSON.stringify(result);
      } else {
        data.elements.giftcardsHidden.value = '';
      }
    });
  }
};

/**
 * Calculate to pay price from total price minus giftcards
 * @param {String} [exceptsCardNumber]
 * @returns {Number}
 */
var calculateGiftcards = function(exceptsCardNumber) {
  var giftcardsSum = 0;
  _forEach(data.items, function(item) {
    if (item.cardNumber !== exceptsCardNumber) {
      giftcardsSum += item.amount;
    }
  });
  return mutils.priceRound(giftcardsSum);
};

var checkStatusFunctions = {
  service: function() {
    if (!data.serviceAvailable) {
      toReturn.disable(data.scheduled ? data.scheduled.getSentence() : window.translate.giftcard_serviceNotAvailable);
      return false;
    } else {
      toReturn.enable();
      return true;
    }
  }
};

var editLock = false;
var isInitDone = false;
var addGiftCard;
var toReturn = {
  init: function(giftcardFromElement, addGiftCardInstance) {
    addGiftCard = addGiftCardInstance;
    findGiftcardFormElements(giftcardFromElement);
    findElements();
    loadValues();
    bindEvents();

    var enabled = true;
    _forIn(checkStatusFunctions, function(checkFunction) {
      if (toReturn.status.all) {
        if (enabled) {
          enabled = checkFunction();
        }
      }
    });

    isInitDone = true;
  },
  /**
   * Return true if wos init
   * @return {boolean}
   */
  isInitDone: function() {
    return isInitDone;
  },
  isGiftcardsOn: function() {
    return this.isInitDone() && this.status.all;
  },
  /**
   * Used when added giftcard amount is changed
   *
   * 1. Calculates to pay with given card
   * 2. If to pay is less then zero then reduce other cards until it isn't
   * Returns rest of under zero part after reducing all other cards
   * @param {Object} giftCardObject
   * @param {number} newAmount
   * @return {number}
   */
  suggestAmount: function(giftCardObject, newAmount) {
      //check maximum amount of giftcard
      if (newAmount > giftCardObject.balance) {
        newAmount = giftCardObject.balance;
        this.showError(window.translate.giftcard_amountInGiftCardsAdjusted);
      }

      //check giftcard limit
      var oldAmount = giftCardObject.amount;
      giftCardObject.operation.setAmount(0);
      var totalGiftcardAmount = this.getTotalGiftcardsAmount();
      var GiftcardMaximumTotalValue = GiftCardsSettings.fGiftcardMaximumTotalValue;
      var avaibleAmount = GiftcardMaximumTotalValue - totalGiftcardAmount;
      if(newAmount > avaibleAmount){
        newAmount = avaibleAmount;
      }
      giftCardObject.operation.setAmount(oldAmount);

      this.checkTotalGiftcardsAmountReachedAndMaximumGiftcard();
      var toPayAfterThisCard = totalPrices.get.toPayWithoutSupport() + giftCardObject.amount - newAmount;
      if (toPayAfterThisCard >= 0) { return newAmount; }

      // toPayAfterThisCard has negative value -> adjust this difference in newAmount
      newAmount += toPayAfterThisCard;
      this.showError(window.translate.giftcard_amountInGiftCardsAdjusted);
      return newAmount;
  }
  ,
  /**
   * Reduces all cards amount to flatten overpayment and returns rest amount to pay
   * @param {number} overpayment
   * @param {int} [exceptCardNumber]
   * @return {number} rest overpayment
   */
  reduceCardsBy: function(overpayment, exceptCardNumber, isVoucher) {
    var over = overpayment;
    if (over <= 0) {
      return over;
    }
    if(isVoucher === true){
      this.showError(window.translate.giftcard_voucherAdjusted);
    } else {
      this.showError(window.translate.giftcard_amountInGiftCardsAdjusted);
    }
    _forEach(data.items, function(item) {
      if (!(exceptCardNumber > -1) || item.cardNumber !== exceptCardNumber) {
        over -= item.operation.reduceByAmount(over);
        if (!over) {
          return 0;
        }
      }
    });
    return over;
  },
  /**
   * Calculate to pay price from total price minus giftcards and save into variable and page element
   */
  calculateToPayAndUpdate: function() {
    var giftCardsSum = calculateGiftcards();
    totalPrices.update.giftCards(giftCardsSum);
    totalPrices.recalculate();
  },
  getToPayWithoutSupport: function() {
    return totalPrices.get.toPayWithoutSupport();
  },
  getSupportPrice: function() {
    return totalPrices.get.support();
  },
  getMonthlySupportPrice: function() {
    return totalPrices.get.monthlySupport();
  },
  showError: function(error) {
    this.hideError();
    setTimeout(function() {
      $(data.elements.error).each(function() {
        var errorEl = $(this);
        errorEl[0].innerHTML = error;
        errorEl.show();
      });
    }, 150);
  },
  hideError: function() {
    $(data.elements.error).each(function() { $(this).hide(); });
  },
  add: function(giftcard) {
    data.items.push(giftcard);
    // dispatch data-layer add action
    window.appState.dispatch({ type: "CART_GIFTCARD_ADD", giftCard: giftcard });
  },
  getAllCards: function() {
    return data.items;
  },
  disableEdits: function() {
    _forEach(data.items, function(item) {
      item.operation.disableEdit();
    });
  },
  /**
   * Returns true if there is already card with this card number
   * @param {number} cardNumber
   * @return {boolean}
   */
  cardAlreadyExist: function(cardNumber) {
    for (var i = 0; i < data.items.length; i++) {
      if (data.items[i].cardNumber === cardNumber) {
        return true;
      }
    }
    return false;
  },
  limitIsReached: function() {
    return data.giftcardsLimit <= data.items.length;
  },
  remove: function(item) {
    for (var i = 0; i < data.items.length; i++) {
      if (data.items[i].cardNumber === item.cardNumber) {
        data.items.splice(i, 1);
      }
    }
    this.checkTotalGiftcardsAmountReachedAndMaximumGiftcard();
    $(document).trigger('giftCardsChanged');
    // dispatch data-layer remove action
    window.appState.dispatch({ type: "CART_GIFTCARD_REMOVE", giftCard: item });
  },
  removeAllCards: function() {
    for (var i = data.items.length - 1; i >= 0; i--) {
      data.items[i].operation.removeGiftcard();
    }
    this.checkTotalGiftcardsAmountReachedAndMaximumGiftcard();
    $(document).trigger('giftCardsChanged');
  },
  editLock: function(locked) {
    if (locked === false || locked) {
      editLock = locked;
      return;
    }
    if (editLock) {
      this.showError(window.translate.giftcard_alertGiftcardNotSaved);
      scrollIfNotOnScreen(data.elements.error);
    }
    return editLock;
  },
  getEditLock: function() {
    return editLock;
  },
  getCarsPrefix: function() {
    return data.prefix;
  },
  /**
   * Disable functionality (elements and status variable). Give permanently false if it can change until reload
   * @param {string} reasonMessage
   * @param {boolean} [permanently] default true
   */
  disable: function(reasonMessage, permanently) {
    data.elements.giftcardForm.label.innerHTML = reasonMessage;
    data.elements.giftcardForm.label.className = 'disabled';
    domutils.hide(data.elements.giftcardForm.formContent);
    this.status.add = false;
    this.status.all = permanently === false;
  },
  enable: function() {
    data.elements.giftcardForm.label.innerHTML = data.defaultGiftcardLabel;
    data.elements.giftcardForm.label.className = '';
    domutils.show(data.elements.giftcardForm.formContent);
    this.status = {add: true, all: true};
  },
  status: {
    add: true,
    all: true
  },
  getTotalGiftcardsAmount: function(){
    var totalAmount = 0;
    for(var i = 0; i < data.items.length;i++){
      totalAmount += data.items[i].amount;
    }
    return totalAmount;
  },

  /**
   * Check if maximum giftcard amount was reached
   * @returns {Boolean}
   */
  isTotalGiftcardsAmountReached: function(){
    var totalAmount = 0;
    for(var i = 0; i < data.items.length;i++){
      totalAmount += data.items[i].amount;
    }
    return totalAmount === data.giftcardMaximumTotalValue;
  },

  checkTotalGiftcardsAmountReachedAndMaximumGiftcard: function(){
    if (this.limitIsReached()) {
      this.disable(window.translate.giftcard_limitReached, false);
      return false;
    }

    //check total amount
    var totalGiftcardsAmountReached = this.isTotalGiftcardsAmountReached();
    if(totalGiftcardsAmountReached){
      this.disable(window.translate.giftcard_max_val_reached);
      return;
    }

    this.enable();

  },
  checkAmountToPayIsZero: function(){
    if (totalPrices.get.toPay() === 0){
      this.disable(translate.pay_with_giftcard);
      this.status.all = true;
      totalPrices.messages.show(window.translate.giftcard_clickPlaceOrder, window.translate.giftcard_paid);
    }
  },
  checkStatusFunctions: checkStatusFunctions
};

module.exports = toReturn;
